import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Skeleton, Chip, Alert } from '@mui/material';
import { red, orange, grey, green } from '@mui/material/colors';
import WarningIcon from '@mui/icons-material/Warning';
import api from '../../../services/api';

const urgencyColor = (days) => {
    if (days == null) return grey[600];
    if (days >= 7) return red[700];
    if (days >= 3) return red[500];
    if (days >= 1) return orange[600];
    return orange[400];
};

export default function ProblematicHosts() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/hermes/dashboard/top_problematic_hosts?limit=10')
            .then(r => setItems(r.data || []))
            .finally(() => setLoading(false));
    }, []);

    return (
        <Paper elevation={2} sx={{ p: 2 }}>
            <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                <WarningIcon sx={{ color: orange[700] }} />
                <Typography variant="h6" sx={{ fontFamily: 'Montserrat', fontWeight: 500 }}>
                    Hosts que precisam de atenção
                </Typography>
            </Box>

            {loading ? (
                <Skeleton variant="rectangular" height={200} />
            ) : items.length === 0 ? (
                <Alert severity="success">Nenhum host com pendência.</Alert>
            ) : (
                <Box display="flex" flexDirection="column">
                    {items.map((h, i) => {
                        const days = h.days_without_backup;
                        const color = urgencyColor(days);
                        return (
                            <Box key={h.host_id}
                                 display="flex" alignItems="center" gap={2}
                                 py={1.25} px={1}
                                 borderBottom={i < items.length - 1 ? `1px solid ${grey[200]}` : 'none'}
                                 sx={{ '&:hover': { bgcolor: grey[50] } }}>

                                <Box sx={{ width: 4, alignSelf: 'stretch', bgcolor: color, borderRadius: 1 }} />

                                <Box flex={1} minWidth={0}>
                                    <Typography variant="body2" fontWeight={600} noWrap>
                                        {h.host_name}
                                        <Typography component="span" variant="caption" color="text.secondary" ml={1}>
                                            {h.ip}
                                        </Typography>
                                    </Typography>
                                    <Box display="flex" gap={1} flexWrap="wrap" mt={0.3}>
                                        <Chip label={h.vendor || '—'} size="small" variant="outlined" sx={{ height: 18 }} />
                                        <Chip label={h.type || '—'} size="small" variant="outlined" sx={{ height: 18 }} />
                                    </Box>
                                </Box>

                                <Box textAlign="right" minWidth={120}>
                                    <Typography variant="body2" fontWeight={700} sx={{ color }}>
                                        {days == null ? 'nunca' : days === 0 ? 'pendente hoje' : `${days}d sem backup`}
                                    </Typography>
                                    {h.fail_count_30d > 0 && (
                                        <Typography variant="caption" color="text.secondary" display="block">
                                            {h.fail_count_30d} falhas em 30d
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            )}
        </Paper>
    );
}
